import React, { lazy, Suspense } from 'react';

const LazyLottieComponent = lazy(() => import('lottie-react'));

const LottieAnimation = ({ animationData, width = 300, height = 300, loop = true }: any) => {
  return (
    <div style={{ width, height }}>
      <Suspense fallback={null}>
        <LazyLottieComponent
          className='w-full h-full'
          animationData={animationData}
          loop={loop}
          autoplay={true}
        />
      </Suspense>
    </div>
  );
};

export default LottieAnimation;
